import { FilterOutlined } from "@ant-design/icons";
import { Input, Select } from "antd";

const { Search } = Input;

export const ComponentSearch = ({ searchType, onSearch, loadingBankAccounts, onTypeChange, t }) => {

    return (<>
        <Search
            style={{ minWidth: 275, }}
            placeholder={t("Search from", { type: t(searchType) })}
            allowClear
            onChange={(e) => onSearch(e.target.value)}
            onSearch={onSearch}
            loading={loadingBankAccounts}
            disabled={loadingBankAccounts}
            addonBefore={
                <Select
                    className="select-before"
                    value={searchType}
                    onChange={onTypeChange}
                    loading={loadingBankAccounts}
                    disabled={loadingBankAccounts}
                    options={[{ value: "accountName", label: t("account Name") }, { value: "accountNumber", label: t("account Number") },]}
                    suffixIcon={<FilterOutlined />}
                />
            }
        />
    </>)
}